export const getLoginUrlWithCurrentPageRedirect = (
    currentLocation: Pick<Location, 'pathname' | 'search' | 'hash'> = window.location,
): string => {
    if (currentLocation.pathname === '/login') {
        return '/login';
    }

    const redirectPath = currentLocation.pathname + currentLocation.search + currentLocation.hash;

    return `/login?redirect=${encodeURIComponent(redirectPath)}`;
};
